<div class="container">
    <div class="card">
        <p style="text-align:justify; line-height:116%; font-size:14pt" class="heading1">
				Acceptable Use Policy – Eartheye Space Technologies Pte. Ltd
			</p>
			<p style="text-align:justify">
				Last updated: September 24, 2025
			</p>
			<p style="text-align:justify" class="heading1">
				General
			</p>
			<p style="text-align:justify">
				Eartheye Space Technologies Pte. Ltd (Eartheye, we, us or our) to you for the use of any services provided by us through our Eartheye Tasking platform (Platform) (together, Services). This AUP applies to all users of the Services.
			</p>
			<p style="text-align:justify" class="heading1">
				Purpose
			</p>
			<p style="text-align:justify">
				The primary purpose of this AUP is to ensure the intended, efficient, lawful, and ethical use of the Services, Platform and the hosting infrastructure for the benefit of all our users. It sets out the things that you can and cannot do in connection with the Services and applies in addition to any terms and conditions of use you accepted in connection with the Services (Applicable Terms).
			</p>
			<p style="text-align:justify" class="heading1">
				Your responsibilities
			</p>
			<p style="text-align:justify">
				You must only use the Services in good faith and for their intended purpose.
			</p>
			<p style="text-align:justify">
				You must use the Services in compliance with applicable laws in any jurisdiction where Services are being offered or received, including as to the treatment of personal information.
			</p>
			<p style="text-align:justify">
				You must comply with any third party’s intellectual property rights, including copyright (including moral rights), trade mark, design, patent, trade or other proprietary rights, or any rights of registration of such rights.
			</p>
			<p style="text-align:justify">
				You must use the Services in a manner that does not interfere with or harm other users of the Services or the Platform.
			</p>
			<p style="text-align:justify">
				You must comply with any instruction from us to delete, remove or modify your use of the Services that:
			</p>
			<ul style="margin:0pt; padding-left:0pt">
				<li style="margin-left:27.6pt; text-align:justify; line-height:116%; padding-left:8.4pt; font-family:serif; font-size:10pt">
					<span style="line-height:116%; font-family:Barlow; font-size:12pt">in our opinion, contravenes this AUP or the Applicable Terms;</span>
				</li>
				<li style="margin-left:27.6pt; text-align:justify; line-height:116%; padding-left:8.4pt; font-family:serif; font-size:10pt">
					<span style="line-height:116%; font-family:Barlow; font-size:12pt">is required by law; or</span>
				</li>
				<li style="margin-left:27.6pt; text-align:justify; line-height:116%; padding-left:8.4pt; font-family:serif; font-size:10pt">
					<span style="line-height:116%; font-family:Barlow; font-size:12pt">is directed by a third party relying, or purporting to rely, on a legal right; and</span>
				</li>
				<li style="margin-left:27.6pt; text-align:justify; line-height:116%; padding-left:8.4pt; font-family:serif; font-size:10pt">
					<span style="line-height:116%; font-family:Barlow; font-size:12pt">comply with any request from us to assist in preventing any breach of this AUP, or in respect of any legal action that is taken in respect of the Services, our content or our website located at <a href="https://eartheye.space/" target="_blank">https://eartheye.space</a> (Website).</span>
				</li>
			</ul>
			<p style="text-align:justify">
				You must not use the Services if you or any intended recipients are, or are employed or engaged by, a direct competitor of Eartheye or operate products or services which are in direct competition with Eartheye.
			</p>
			<p style="text-align:justify">
				You must not use the Services in any way intended to avoid incurring any fees or charges payable for the Services.
			</p>
			<p style="text-align:justify">
				You must not copy, alter, modify, create derivative works from, reproduce, resell, sub-licence, reverse assemble, reverse engineer or reverse compile the Services or the Platform, other than in the ordinary course of using the Services.
			</p>
			<p style="text-align:justify">
				You must not view, analyse or deconstruct the Services or the Platform for any purpose of, or associated with:
			</p>
			<ul style="margin:0pt; padding-left:0pt">
				<li style="margin-left:27.6pt; text-align:justify; line-height:116%; padding-left:8.4pt; font-family:serif; font-size:10pt">
					<span style="line-height:116%; font-family:Barlow; font-size:12pt">replicating the Services or the Platform or any part of them; or</span>
				</li>
				<li style="margin-left:27.6pt; text-align:justify; line-height:116%; padding-left:8.4pt; font-family:serif; font-size:10pt">
					<span style="line-height:116%; font-family:Barlow; font-size:12pt">developing an alternative solution to the solution offered by the Services or the Platform;</span>
				</li>
			</ul>
			<p style="text-align:justify">
				You must not create internet links to or from the Services or frame, mirror or place any pop-up windows on any content constituting part of the Services, other than in the ordinary course of the Services without our prior written consent.
			</p>
			<p style="text-align:justify">
				You must not engage in any conduct that is illegal in connection with the Services.
			</p>
			<p style="text-align:justify">
				You must not load or send any information in connection with the Services that, in our opinion:
			</p>
			<ul>
				<li>
					threatens the integrity and security of the Platform, the hosting infrastructure, the internet, or other users of the Platform and their systems;
				</li>
				<li>
					contains any virus, trojan horse, worm or other programs that have, or may have, an adverse effect on the Services, the Platform, the hosting infrastructure or the internet;
				</li>
				<li>
					transmits information that infringes the rights of others or is abusive, harmful, threatening, sexually explicit, indecent, unlawfully discriminatory, defamatory, libellous, harassing, offensive or otherwise objectionable;
				</li>
				<li>
					contains any information that breaches any applicable laws, codes of conduct or industry standards;
				</li>
				<li>
					is false, misleading or deceptive or is likely to mislead or deceive;
				</li>
				<li>
					breaches any third party's intellectual property rights;
				</li>
			</ul>
			<p style="text-align:justify">
				You must not engage in any act which we believe, in our opinion:
			</p>
			<ul>
				<li>
					is intended or reasonably likely to damage, impair, interrupt, disable, overburden or otherwise interfere with the ordinary integrity, function, operation or delivery of the Services, the Platform or the hosting infrastructure;
				</li>
				<li>
					breaches the provisions of any applicable laws preventing spam or unsolicited emails;
				</li>
				<li>
					provides misleading or fraudulent information as to the origin of, or identity of the person sending, information through the Services;
				</li>
				<li>
					disclose information that is confidential to any third party without their consent in connection with the Services; or
				</li>
				<li>
					aid, abet, counsel, procure or permit any third party to do any of the above.
				</li>
			</ul>
			<p style="text-align:justify" class="heading1">
				If you do not comply with this AUP
			</p>
			<p style="text-align:justify">
				If you use the Services and/or Platform in a manner that does not comply with this AUP, we may in our discretion ask you to modify your behaviour. We may also take any action that we deem, in our discretion, necessary to prevent or remedy that non-compliance, including immediately and without notice:
			</p>
			<ul>
				<li>
					intercepting, removing or altering any content stored in the Platform or in our infrastructure;
				</li>
				<li>
					limiting or blocking access to your ability to use the Services; and/or
				</li>
				<li>
					terminating your receipt of the Services.
				</li>
			</ul>
			<p style="text-align:justify">
				If you breach this AUP, you may also be in breach of any Applicable Terms and we may, in addition to our rights under this AUP, exercise any right or remedy set out in such Applicable Terms.
			</p>
			<p style="text-align:justify" class="heading1">
				Amendments to this AUP
			</p>
			<p style="text-align:justify">
				This AUP may be changed by us in our discretion from time to time. You acknowledge and agree that we are not required to give you notice of any changes to this AUP. Any changed version of this AUP applies from the date that it is posted to our Website.
			</p>
			<p style="text-align:justify" class="heading1">
				Applicable Terms
			</p>
			<p style="text-align:justify">
				This AUP is intended to be read in conjunction with the Applicable Terms, as amended from time to time. If there is any inconsistency between this AUP and any Applicable Terms, those Applicable Terms will prevail to the extent of the inconsistency.
			</p>
			<p style="text-align:justify">
				&#xa0;
			</p>
			<p style="text-align:justify">
				Acceptable Use Policy V01 – Sep. 2025
			</p>
    </div>
</div>